import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Bunkering Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "Remarks", required: false },
  { fieldType: "CurrentPort", required: true },
  { fieldType: "StartOfBunkeringTime", required: true },
  { fieldType: "EndOfBunkeringTime", required: true },
  { fieldType: "BunkersReceived", required: true },
  { fieldType: "ROBItems", required: true },
];

@saveClassByClassNameDecorator()
class ClearVoyageNoonReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageNoonReportGenerator;
